import { ButtonTypeMap } from '@mui/material';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

interface Props {
	title?: string | null;
	content: string | JSX.Element | JSX.Element[];
	handleDismiss?: () => void;
	handleConfirm?: () => void;
	confirmText?: string | null;
	confirmButtonColor?: ButtonTypeMap['props']['color'];
	dismissText?: string | null;
	contentStyle?: Record<string, string>;
	titleStyle?: Record<string, string>;
	confirmButtonInTopRightOfHeader?: boolean;
}

const defaultContentStyle = {
	display: 'flex',
	flexDirection: 'column',
	padding: '30px 0',
	maxWidth: '75%',
	margin: 'auto',
};

const defaultTitleStyles = {
	fontWeight: 'bold',
	textAlign: 'center',
};

export const SimpleModal = ({
	title = '',
	content,
	handleDismiss,
	handleConfirm,
	confirmText,
	confirmButtonColor,
	dismissText,
	contentStyle = defaultContentStyle,
	titleStyle = defaultTitleStyles,
	confirmButtonInTopRightOfHeader = false,
}: Props): JSX.Element => (
	<div>
		<Grid container sx={{ justifyContent: 'space-between' }}>
			{title ? (
				<Typography data-cy='modal-title-text' style={titleStyle} variant='h6'>
					{title}
				</Typography>
			) : null}
			{confirmButtonInTopRightOfHeader && (
				<Grid item xs={2}>
					<Button
						size='small'
						variant='outlined'
						fullWidth
						color={confirmButtonColor}
						onClick={handleConfirm}
						data-cy='modal-confirm-button-in-header'
					>
						{confirmText}
					</Button>
				</Grid>
			)}
		</Grid>
		<div style={contentStyle} data-cy='modal-body-text'>
			{content}
		</div>
		{(handleDismiss || (handleConfirm && !confirmButtonInTopRightOfHeader)) && (
			<Grid spacing={2} container>
				{handleDismiss ? (
					<Grid item xs={6}>
						<Button fullWidth onClick={handleDismiss} data-cy='modal-cancel-button'>
							{dismissText}
						</Button>
					</Grid>
				) : (
					<Grid item xs={6} />
				)}
				{handleConfirm && !confirmButtonInTopRightOfHeader ? (
					<Grid item xs={!handleDismiss ? 2 : 6}>
						<Button
							fullWidth
							color={confirmButtonColor}
							onClick={handleConfirm}
							data-cy='modal-confirm-button'
						>
							{confirmText}
						</Button>
					</Grid>
				) : (
					<Grid item xs={6} />
				)}
			</Grid>
		)}
	</div>
);
